import React from "react";
import { SortDrawer } from "@app/components/pageCollection/SortDrawer";
import { FilterChip } from "@app/components/SortDrawer/FilterChip";
import { ClearAll, FiltersSelected, useFilters, useResults } from "@usereactify/search";
import { useSortDrawer } from "@app/context/SortDrawerContext";

export const Filters = () => {
  const { setIsSortDrawerOpen } = useSortDrawer();
  const { resultStats } = useResults();
  const { selected } = useFilters();

  return (
    <div className="space-y-2">
      <div className="py-1 flex gap-2">
        <button className="button button--small button--black" onClick={() => setIsSortDrawerOpen(true)}>
          <span dangerouslySetInnerHTML={{ __html: window.iconFilterSm }} />
          Filter & Sort
        </button>
        <button
          className="maxLg:hidden button button--small button--outline focus-visible-minimal"
          onClick={() => setIsSortDrawerOpen("category")}
        >
          Category
        </button>
        <button
          className="maxLg:hidden button button--small button--outline focus-visible-minimal"
          onClick={() => setIsSortDrawerOpen("season")}
        >
          Season
        </button>
        <button
          className="maxLg:hidden button button--small button--outline focus-visible-minimal"
          onClick={() => setIsSortDrawerOpen("gender")}
        >
          Gender
        </button>
        <button
          className="maxLg:hidden button button--small button--outline focus-visible-minimal"
          onClick={() => setIsSortDrawerOpen("size")}
        >
          Size
        </button>
        <div className="flex-1 flex items-center justify-end text-base text-neutrals-secondaryGrey">
          {resultStats?.numberOfResults || 0} products
        </div>
      </div>

      {selected.length > 0 && (
        <div className="flex flex-wrap gap-2">
          <FiltersSelected
            render={({ selectedFilters, handleRemove }) => (
              <>
                {selectedFilters.map((filter) => (
                  <>
                    {Array.isArray(filter.value) ? (
                      filter.value.map((v) => (
                        <FilterChip
                          key={filter.key + v}
                          label={typeof v === "string" ? v : v.label}
                          onClose={() => handleRemove(filter.key, typeof v === "string" ? [v] : undefined)}
                        />
                      ))
                    ) : (
                      <FilterChip
                        key={filter.key}
                        label={typeof filter.value === "string" ? filter.value : filter.value.label}
                        onClose={() => handleRemove(filter.key)}
                      />
                    )}
                  </>
                ))}
              </>
            )}
          />

          <ClearAll
            render={({ clearAll }) => {
              return (
                <button className="button button--small button--text button--black" onClick={clearAll}>
                  <span className="button-text">Clear All</span>
                </button>
              );
            }}
          />
        </div>
      )}

      <SortDrawer />
    </div>
  );
};
